import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faXmark,
  faAngleRight,
} from "@fortawesome/free-solid-svg-icons";
import constants from "../constants/constants";
import { useUserParams } from "../hooks/useUserParams";


const MobileNav = ({ pathname }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [headerPosition, setHeaderPosition] = useState(-100);
  const [headerTiming, setHeaderTiming] = useState(0.8);
  const { getCurrentLogo } = useUserParams();

  useEffect(() => {
    // Reset menu state when pathname changes
    setIsMenuOpen(false);
    setHeaderPosition(-100);
    document.body.style.overflow = "auto";
  }, [pathname]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setHeaderPosition(isMenuOpen ? -100 : 0);
    document.body.style.overflow = !isMenuOpen ? "hidden" : "auto";
  };

  const navClick = () => {
    setHeaderPosition(-100);
    setHeaderTiming(0);
    setTimeout(() => {
      setHeaderTiming(0.8);
    }, 100);
    if (typeof window != "undefined" && window.document) {
      document.body.style.overflow = "auto";
    }
  };

  const navItems = [
    { href: "/", label: "Home" },
    { href: "/about", label: "About" },
    { href: "/calculator", label: "Mortgage Calculator" },
    { href: "/listings", label: "Listings" },
    { href: "/evaluation", label: "Free Home Evaluation" },
    { href: "/real-estate-reports", label: "Free Real Estate Reports" },
    { href: "/contact", label: "Contact" },
  ];

  return (
    <>
      <div className="relative w-full h-40 z-30 bg-light-grey grid grid-cols-3 items-center">
        <div className="z-20 transition-opacity duration-700 ease-in-out w-full h-full absolute bg-white" />
        <button
          onClick={toggleMenu}
          className="z-30 text-3xl px-4 text-mb-red cursor-pointer"
        >
          <FontAwesomeIcon
            icon={isMenuOpen ? faXmark : faBars}
            className="w-8 h-8"
          />
        </button>
        <div className="flex justify-center">
          <div className="rounded-full border-8 border-[#8B5C2A] p-2 bg-white shadow-lg">
            <img
              src={getCurrentLogo()}
              alt="Logo"
              width={120}
              height={120}
              className="z-30 h-28 w-28 object-contain"
            />
          </div>
        </div>
      </div>

      <nav
        style={{
          transition: `translate ${headerTiming}s cubic-bezier(0, .52, 0, 1)`,
          translate: `${headerPosition}vw`,
        }}
        className={`flex flex-col gap-12 px-6 py-9 bg-[#f9f9f9] fixed z-20 w-[75%] h-full child:tracking-wider child:font-bold`}
      >
        {constants.NAV_ITEMS.map((item) => (
          <Link
            key={item.href || item.label}
            to={item.href || (item.items[0] && item.items[0].href) || "#"}
            onClick={navClick}
            className={`pl-4 ${
              pathname === item.href
                ? "border-l-4 border-[#8B5C2A] text-primary"
                : "border-l-4 border-transparent"
            } py-2`}
          >
            {item.label}
            {pathname !== item.href && (
              <FontAwesomeIcon
                className="pl-4 w-4 h-4 inline-block"
                icon={faAngleRight}
              />
            )}
          </Link>
        ))}
      </nav>
    </>
  );
};

export default MobileNav;
